fragment toegewezenBijdragenContent on toegewezenBijdragen_default_Entry {
    title
    aanvrager: plaintext
    regisseur: plaintext2
    scenarist: plaintext3
    bedrag: plaintext4
    date: plainDate

    toegewezenBijdrageCategory {
        title
    }

    toegewezenBijdragesoort {
        title
    }
}
